import { ViteReactSSG } from 'vite-react-ssg';

import { routes } from './routes';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/sections.css';
import './styles/screens.css';
import './styles/animations.css';
import './styles/blog.css';

export const createRoot = ViteReactSSG({ routes });
